import "@/App.css";
import Experience from "@/components/Experience";

function App() {
  return <Experience />;
}

export default App;
